(() => {
  const ROOT_SELECTOR = '[data-section-type="collection-article"]';

  const hydrateLazyImages = (container) => {
    container.querySelectorAll('img.inviewImg[data-src]').forEach((img) => {
      const src = img.getAttribute('data-src');
      if (!src) return;
      if (img.getAttribute('src') !== src) {
        img.setAttribute('src', src);
      }
      img.removeAttribute('data-src');
    });
  };

  const initSwipers = (container) => {
    if (typeof window.Swiper !== 'function') return;

    container.querySelectorAll('.main-swiper').forEach((swiperElement) => {
      if (swiperElement.classList.contains('swiper-initialized')) return;

      new window.Swiper(swiperElement, {
        loop: true,
        slidesPerView: 1,
        effect: 'fade',
        autoplay: {
          delay: 1500
        }
      });
    });
  };

  const initInview = (container) => {
    const targets = container.querySelectorAll('.tO');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('inview'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('inview');
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.1
      }
    );

    targets.forEach((target) => observer.observe(target));
  };

  let initialized = false;

  const initArticle = () => {
    if (initialized) return true;
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;

    const detailContent = root.querySelector('.collection_detail__content');
    if (!detailContent) return false;

    hydrateLazyImages(detailContent);

    detailContent.addEventListener('click', (event) => {
      const creditTrigger = event.target.closest('.link_on[data-credit]');
      if (creditTrigger && detailContent.contains(creditTrigger)) {
        event.preventDefault();
        event.stopPropagation();

        const creditId = creditTrigger.getAttribute('data-credit');
        if (!creditId) return;

        const globalCreditArea = detailContent.querySelector('.credit_area');
        const creditBox = detailContent.querySelector(`.credit_box.credit${creditId}`);
        if (!globalCreditArea || !creditBox) return;

        document.body.classList.add('credit-open');
        globalCreditArea.classList.add('active');
        creditBox.classList.add('active');
        return;
      }

      const button = event.target.closest('.toggle_btn_box');
      if (button && detailContent.contains(button)) {
        event.preventDefault();
        event.stopPropagation();

        const style = button.closest('.style');
        if (!style) return;

        const creditArea = style.querySelector('.credit_area');
        if (!creditArea) return;

        creditArea.classList.toggle('open');
        button.classList.toggle('active');
        return;
      }

      const creditArea = event.target.closest('.credit_area');
      if (creditArea && detailContent.contains(creditArea)) {
        const closeArea = event.target.closest('.close_area');
        if (closeArea) {
          document.body.classList.remove('credit-open');
          creditArea.classList.remove('active');
          detailContent.querySelectorAll('.credit_box.active').forEach((box) => box.classList.remove('active'));
          return;
        }
        event.stopPropagation();
      }
    });

    document.addEventListener('click', () => {
      detailContent.querySelectorAll('.credit_area.open').forEach((openArea) => {
        openArea.classList.remove('open');
        const style = openArea.closest('.style');
        if (!style) return;
        const activeButton = style.querySelector('.toggle_btn_box.active');
        if (activeButton) activeButton.classList.remove('active');
      });

      detailContent.querySelectorAll('.credit_box.active').forEach((box) => box.classList.remove('active'));
      detailContent.querySelectorAll('.credit_area.active').forEach((area) => area.classList.remove('active'));
      document.body.classList.remove('credit-open');
    });

    initInview(detailContent);
    initSwipers(detailContent);

    if (typeof window.Swiper !== 'function') {
      window.addEventListener('load', () => initSwipers(detailContent), { once: true });
    }

    initialized = true;
    return true;
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        if (initArticle()) return;

        let tries = 0;
        const retry = window.setInterval(() => {
          tries += 1;
          if (initArticle() || tries > 20) {
            window.clearInterval(retry);
          }
        }, 150);
      },
      { once: true }
    );
  } else {
    if (initArticle()) return;

    let tries = 0;
    const retry = window.setInterval(() => {
      tries += 1;
      if (initArticle() || tries > 20) {
        window.clearInterval(retry);
      }
    }, 150);
  }
})();
